/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Current status of the media preview generation
 */
export type MediaPreviewResultStatus = typeof MediaPreviewResultStatus[keyof typeof MediaPreviewResultStatus];


export const MediaPreviewResultStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
} as const;
